import { ModalComponent, PulseOpsFormat, TaskComment } from '@pulseops/common'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, Text, useWindowDimensions } from 'react-native'
import { Panel } from '../service-inquiry/comment/commentPanel'
type CommentPopupProps = {
  PSComment: boolean
  PSCommentData: TaskComment[]
  isLoading: boolean
  setPSComment: (value: boolean) => void
  setPSCommentData: (value: TaskComment[]) => void
}
export const CommentPopup = (props: CommentPopupProps) => {
  const { t } = useTranslation()
  const { PSComment, setPSComment, PSCommentData, setPSCommentData, isLoading } = props
  const { height } = useWindowDimensions()
  return (
    <ModalComponent
      title={t('ServiceInquiry:CommentDetail')}
      visible={PSComment}
      onClose={() => {
        setPSComment(false), setPSCommentData([])
      }}
      actions={[
        {
          text: t('common:Cancel'),
          type: 'filled',
          disabled: false,
          loading: isLoading,
          onlyWide: false,
          style: { height: 40 },
          action: () => {
            setPSComment(false), setPSCommentData([])
          }
        }
      ]}
      modalWidth={864}
    >
      {PSCommentData.length > 0 && (
        <View
          style={{
            marginHorizontal: 20,
            marginTop: 20,
            maxHeight: height - 200,
            borderWidth: 1,
            borderRadius: 8,
            borderColor: '#dcdcdc',
            paddingTop: 16,
            paddingHorizontal: 16
          }}
        >
          {PSCommentData.map((user, index) => (
            <Panel
              key={index}
              title={user.username}
              comment={PulseOpsFormat.datetoFormat(user.time, 'DD/MM/YYYY HH:mm:ss')}
              isHiddenTitle={false}
              isExand={true}
              isHaveComment
            >
              <Text>{user.message}</Text>
            </Panel>
          ))}
        </View>
      )}
      {PSCommentData.length === 0 && (
        <View
          style={{
            marginHorizontal: 20,
            marginTop: 20,
            maxHeight: height - 200,
            borderWidth: 1,
            borderRadius: 8,
            borderColor: '#dcdcdc',
            paddingHorizontal: 16,
            minHeight: 80
          }}
        >
          <Text style={{ marginVertical: 'auto' }}>{t('ServiceInquiry:CommentNotFound')}</Text>
        </View>
      )}
    </ModalComponent>
  )
}